import { Icon } from '@iconify/react/dist/iconify.js'
import { useContext, useState } from 'react'
import { ConfigContext } from '../context/GlobalContext';
import { User } from 'lucide-react';
import { logEvent } from '../helper/shakebug';

const CopyLink = () => {
    const { state, dispatch } = useContext(ConfigContext);
    const referralCode = state?.SET_USER?.referral_code;
    const baseUrl = process.env.REACT_APP_FRONTEND_URL || window.location.origin;
    const referralLink = `${baseUrl.endsWith('/') ? baseUrl : baseUrl + '/'}login?refferral_code=${referralCode}`;
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard?.writeText(referralLink);
        logEvent("User Action", "Refer to some one");
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="col-xxl-5 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="card h-100 radius-8 border">
                <div className="card-body p-24">
                    <h6 className="mb-12 fw-semibold text-lg mb-16">Referral Link</h6>

                    <div className="d-flex align-items-center gap-2">
                        {/* Text field */}
                        <input
                            type="text"
                            value={referralLink}
                            readOnly
                            className="form-control flex-grow-1"
                        />

                        {/* Copy button */}
                        <button
                            onClick={handleCopy}
                            className="btn btn-primary d-flex align-items-center flex-shrink-0 gap-1"
                        >
                            <Icon icon="solar:copy-bold" className="icon" />
                            {copied ? "Copied!" : "Copy"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CopyLink
